import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=d143e220&"
import script from "./Component.vue?vue&type=script&lang=ts&"
export * from "./Component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports